import { AFFILIATE } from 'constants/components'

const isNotAffiliateFunc = (context?: string) => {
  const isNotAffiliate = context !== AFFILIATE

  return isNotAffiliate
}

export default isNotAffiliateFunc
